<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    document.title = 'CNHO.IO-Create Your First Web3 Global Wallet with Cosmos CNH Stablecoin！';
  }
}
</script>

<style>
#app {
  font-family: Roboto-Bold,Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  padding:0;
  background: #006e54;
}
</style>
